// Registro canônico de menus por plataforma para o esquema de autorização.
// Deve ficar em sincronia com backend/src/config/menuPermissionKeys.ts
export type PlatformId = 'crm' | 'marketing' | 'seller' | 'business-core' | 'flow';

export interface MenuDef {
  key: string; // "plataforma.menu"
  label: string;
}

export interface PlatformDef {
  id: PlatformId;
  label: string;
  menus: MenuDef[];
}

export const MENU_REGISTRY: PlatformDef[] = [
  {
    id: 'crm',
    label: 'CRM',
    menus: [
      { key: 'crm.conexoes', label: 'Conexões' },
      { key: 'crm.chat-crm', label: 'Chat CRM' },
      { key: 'crm.contatos', label: 'Contatos' },
      { key: 'crm.funis', label: 'Funis' },
      { key: 'crm.formularios', label: 'Formulários' },
      { key: 'crm.follow-up', label: 'Follow-up' },
      { key: 'crm.campanhas', label: 'Campanhas' },
      { key: 'crm.prospeccao', label: 'Leads Prospecção' },
      { key: 'crm.automacoes', label: 'Automações' },
      { key: 'crm.configuracoes', label: 'Configurações' }
    ]
  },
  {
    id: 'marketing',
    label: 'Marketing',
    menus: [
      { key: 'marketing.brand', label: 'Brand' },
      { key: 'marketing.avatares', label: 'Avatar Influencer' },
      { key: 'marketing.inspirations', label: 'Perfis de inspiração' },
      { key: 'marketing.pesquisa_briefs', label: 'Criar Conteúdo IA' },
      { key: 'marketing.fotos_ecommerce', label: 'Produzir Fotos' },
      { key: 'marketing.videos_ecommerce', label: 'Produzir Vídeos' },
      { key: 'marketing.postagens', label: 'Posts' },
      { key: 'marketing.edicao_video', label: 'Edição de Vídeo' }
    ]
  },
  {
    id: 'seller',
    label: 'Seller',
    menus: [
      // Chaves antigas mantidas; o rotulo diz onde cada uma aparece hoje.
      { key: 'seller.overview', label: 'Hoje' },
      { key: 'seller.listings', label: 'Anúncios · tabela de métricas' },
      { key: 'seller.health', label: 'Anúncios · quadro de saúde (IA)' },
      { key: 'seller.boost', label: 'Anúncios · impulsionar' },
      { key: 'seller.promotions', label: 'Promoções' },
      { key: 'seller.ads-agent', label: 'Ads · tabela de campanhas' },
      { key: 'seller.ads-health', label: 'Ads · quadro de saúde (IA)' },
      { key: 'seller.analysis-config', label: 'Automações (configurar)' },
      { key: 'seller.agente', label: 'Agente (chat)' }
    ]
  },
  {
    id: 'business-core',
    label: 'Business Core',
    menus: [
      { key: 'business-core.produtos', label: 'Produtos' },
      { key: 'business-core.conhecimento', label: 'Base de Conhecimento' },
      { key: 'business-core.conexoes', label: 'Conexões' },
      { key: 'business-core.mcp', label: 'MCP (conexões com Claude, ChatGPT...)' },
      { key: 'business-core.creditos', label: 'Créditos' },
      { key: 'business-core.usuarios', label: 'Usuários' }
    ]
  },
  {
    id: 'flow',
    label: 'Flow',
    menus: [
      { key: 'flow.inicio', label: 'Início' },
      { key: 'flow.agenda', label: 'Minha Agenda' },
      { key: 'flow.tarefas', label: 'Minhas Tarefas' },
      { key: 'flow.areas', label: 'Áreas' },
      { key: 'flow.conversas', label: 'Conversas' },
      { key: 'flow.documentos', label: 'Documentos' },
      { key: 'flow.comentarios', label: 'Comentários' }
    ]
  }
];

export const ALL_MENU_KEYS: string[] = MENU_REGISTRY.flatMap(p => p.menus.map(m => m.key));

export const PLATFORM_LANDING_PATHS: Record<PlatformId, string> = {
  crm: '/contatos',
  marketing: '/marketing-studio',
  seller: '/seller',
  'business-core': '/business-core',
  flow: '/flow'
};

const CRM_MENU_PATHS: Record<string, string> = {
  'crm.conexoes': '/conexoes',
  'crm.chat-crm': '/chat-crm',
  'crm.contatos': '/contatos',
  'crm.funis': '/funis',
  'crm.formularios': '/formularios',
  'crm.follow-up': '/follow-up',
  'crm.campanhas': '/campanhas',
  'crm.prospeccao': '/prospeccao',
  'crm.automacoes': '/automacoes',
  'crm.configuracoes': '/configuracoes'
};

export function getPlatformLandingPath(platform: PlatformId, allowedMenus: string[] | null): string {
  if (platform !== 'crm' || allowedMenus === null) return PLATFORM_LANDING_PATHS[platform];
  const firstCrmMenu = MENU_REGISTRY[0].menus.find(menu => allowedMenus.includes(menu.key));
  return firstCrmMenu ? CRM_MENU_PATHS[firstCrmMenu.key] : PLATFORM_LANDING_PATHS.crm;
}
